import { useMutation, useQueryClient } from "@tanstack/react-query";

import { logger } from "#app/monitoring/Logger";
import { showErrorToast } from "#app/notifications";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";
import { MaterialGradeType } from "shared";

import { predictMaterial } from "../../quoteRequestLines/infra/predictMaterial.api";

type Options = {
  onSuccess?: () => void;
};

export const usePredictMaterial = (options?: Options) => {
  const queryClient = useQueryClient();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({
      quoteRequestLineId,
      payload,
    }: {
      quoteRequestLineId: string | undefined;
      payload: {
        materialGrade: MaterialGradeType;
        quantity: number;
      };
    }) => predictMaterial(quoteRequestLineId, payload),
    onSuccess: async (data, variables) => {
      if (!data) {
        return;
      }

      await queryClient.invalidateQueries(
        quoteRequestLineQuery({ id: variables.quoteRequestLineId }),
      );

      options?.onSuccess?.();
    },
    onError: (error) => {
      logger.error(error);
      showErrorToast({
        title: "Une erreur est survenue",
        message: "Veuillez vérifier les données saisies et réessayer.",
      });
    },
  });

  return {
    predictMaterial: mutateAsync,
    ...rest,
  };
};
